module.exports = "/images/va.svg?5b621fb8c97bac5c4a61e962cbe3268c";